function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "fill-primary",
  d: "M3.08 3.08c4.105-4.106 10.764-4.106 14.87 0 4.105 4.105 4.105 10.764 0 14.87-4.106 4.105-10.765 4.105-14.87 0-4.106-4.106-4.106-10.765 0-14.87m1.488 1.488A8.418 8.418 0 1016.473 16.47 8.418 8.418 0 004.568 4.568"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "fill-secondary",
  d: "M17.52 10.51a7.01 7.01 0 00-7.01-7.01v1.682a5.328 5.328 0 015.328 5.328z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "fill-secondary",
  d: "M16.681 9.67a.841.841 0 100 1.682.841.841 0 000-1.682M10.511 3.5a.841.841 0 100 1.682.841.841 0 000-1.682"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "fill-primary",
  d: "M22.944 19.97l5.413 5.413a2.11 2.11 0 010 2.974 2.11 2.11 0 01-2.974 0l-5.413-5.413z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  className: "fill-primary",
  d: "M25.68 22.706l-3.853-3.853a2.109 2.109 0 00-2.974 0 2.11 2.11 0 000 2.974l3.853 3.853z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  className: "fill-primary",
  d: "M16.19 17.776l1.586-1.586 3.13 3.13-1.586 1.586z"
});

var SvgLoupeMcGestion = function SvgLoupeMcGestion(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 29 29",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLoupeMcGestion, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/loupe-mc-gestion.10d035e8.svg";
export { ForwardRef as ReactComponent };